import styled from 'styled-components';

import ReactHeadroom from 'react-headroom';

export const Headroom = styled(ReactHeadroom)`
    & > .headroom {
        z-index: 100 !important;
    }
`;
